module.exports = __webpack_public_path__ + "design/assets/direct-debit/tangerine_account_statement_infomation_fr.svg";